// extracted by mini-css-extract-plugin
export var activityContainer = "_lm-0";
export var typingIndicatorContainer = "_lm-1";
export var typingIndicatorDot = "_lm-2";
export var wave = "_lm-3";